import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { IconWithText } from 'Components';

const ZipAndDownload = ({
  onClick,
}) => (
  <IconWithText
    text={i18n.t('common:Zip and Download All')}
    textOrientation="after"
    multiIcons={['publish', 'business_center']}
    multiIconsRotate={[180, 0]}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}

  />
);

ZipAndDownload.propTypes = {
  onClick: PropTypes.func,
};

ZipAndDownload.defaultProps = {
  onClick: () => null,
};

export default ZipAndDownload;



// WEBPACK FOOTER //
// ./src/components/Actions/ZipAndDownload/ZipAndDownload.jsx